import {
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SHOW_ERROR_NOTIFICATIONS,
  CLEAR_ALL_NOTIFICATIONS
} from '../mutation-type'
import { noticeSchema } from 'src/schema/notices'
import _ from 'lodash'

// initial state
const state = []

// mutations
const mutations = {
  [ADD_NOTIFICATION] (state, notice) {
    let index = _.findIndex(state, ['id', notice.id])
    index > -1
      ? state.splice(index, 1, noticeSchema(notice))
      : state.push(noticeSchema(notice))
  },

  [REMOVE_NOTIFICATION] (state, id) {
    let index = _.findIndex(state, ['id', id])
    if (index < 0) return false
    state.splice(index, 1)
  },

  [SHOW_ERROR_NOTIFICATIONS] (state, type) {
    state = state.map(x => _.set(x, 'show', true))
  },

  [CLEAR_ALL_NOTIFICATIONS] (state) {
    state = state.splice(0, state.length)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notifications.js